import { Controller } from '@hotwired/stimulus'
import { Tab } from 'bootstrap'
import { toggle } from '../../lib/dom'

export default class extends Controller {
  static values = { anchors: Boolean }

  static targets = [
    'tabLink',
    'tabContent',
    'tabContentData',
    'tabContentNoData',
    'filterInput',
    'filterContent',
  ]

  connect() {
    this.setActiveTab()
  }

  setActiveTab() {
    if (this.tabLinkTargets.length > 0) {
      const targetTab = this.findTab(window.location.hash) || this.firstTab()

      if (!targetTab.classList.contains('active')) {
        new Tab(targetTab).show()
      }
    } else {
      this.tabContentTargets[0]?.classList?.add('show')
      this.tabContentTargets[0]?.classList?.add('active')
    }
  }

  filter() {
    const query = this.filterInputTarget.value.trim().toLowerCase()

    this.filterContentTargets.forEach((content) =>
      toggle(
        content,
        !query || content.textContent.toLowerCase().includes(query)
      )
    )

    this.toggleNoData()
  }

  toggleNoData() {
    this.tabContentDataTargets.forEach((tabContentData, index) => {
      toggle(
        this.tabContentNoDataTargets[index],
        tabContentData.clientHeight == 0
      )
    })
  }

  tabClick(event) {
    this.toggleNoData()

    if (this.anchorsValue) {
      const newHash = event.target.getAttribute('data-bs-target')

      if (newHash) window.history.pushState(null, null, newHash)
    }
  }

  firstTab() {
    return this.tabLinkTargets[0]
  }

  findTab(hash) {
    if (!hash) return null

    return this.tabLinkTargets.find((tab) => tab.dataset.bsTarget === hash)
  }
}
